import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClipboardCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.66667 26.8334H21.3333C22.804 26.8334 24 25.6374 24 24.1667V4.16669C24 2.69602 22.804 1.50002 21.3333 1.50002H18.6667C18.6667 1.1464 18.5262 0.80726 18.2761 0.557211C18.0261 0.307163 17.687 0.166687 17.3333 0.166687H6.66667C6.31305 0.166687 5.97391 0.307163 5.72386 0.557211C5.47381 0.80726 5.33333 1.1464 5.33333 1.50002H2.66667C1.196 1.50002 0 2.69602 0 4.16669V24.1667C0 25.6374 1.196 26.8334 2.66667 26.8334ZM2.66667 4.16669H5.33333V6.83335H18.6667V4.16669H21.3333V24.1667H2.66667V4.16669Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.6666 15.6147L8.27596 13.224L6.39062 15.1094L10.6666 19.3854L17.6093 12.4427L15.724 10.5574L10.6666 15.6147Z",
		fill: "currentColor"
	})]
});
export default SvgClipboardCheck;
